var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.489 4.833C16.5716 4.49241 15.6025 4.31211 14.624 4.3C13.795 4.28146 12.9742 4.46726 12.234 4.841C11.4783 5.192 10.6494 5.35628 9.817 5.32C8.70772 5.30132 7.60448 5.15229 6.53 4.876V4.265C6.53 4.19472 6.50208 4.12731 6.45238 4.07762C6.40269 4.02792 6.33528 4 6.265 4C6.19472 4 6.12731 4.02792 6.07762 4.07762C6.02792 4.12731 6 4.19472 6 4.265V5.06C6 5.06 6 5.067 6 5.071C6 5.075 6 5.077 6 5.08V19.629C6 19.6993 6.02792 19.7667 6.07762 19.8164C6.12731 19.8661 6.19472 19.894 6.265 19.894C6.33528 19.894 6.40269 19.8661 6.45238 19.8164C6.50208 19.7667 6.53 19.6993 6.53 19.629V13.37C7.60545 13.6396 8.70841 13.7842 9.817 13.801C10.7359 13.8378 11.6501 13.6522 12.482 13.26C13.1459 12.9271 13.8815 12.7626 14.624 12.781C15.5345 12.7943 16.4364 12.9603 17.292 13.272C17.3322 13.288 17.3757 13.2939 17.4187 13.2892C17.4617 13.2846 17.5029 13.2694 17.5387 13.2452C17.5745 13.2209 17.6038 13.1882 17.6241 13.15C17.6443 13.1118 17.655 13.0693 17.655 13.026V5.079C17.655 5.02611 17.6392 4.97442 17.6097 4.93058C17.5801 4.88674 17.5381 4.85276 17.489 4.833Z",
    fill: "#FFD60F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/Flag.11d3de0dd44e4d2cf180efdcb7f45dcb.svg";
export { ForwardRef as ReactComponent };